module.exports = __webpack_public_path__ + "img/germany.1588f9bd.svg";